import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { SummaryDateLine } from './SummaryDateLine';
import { timeFormatter } from '@act/shared/utilities';

interface AssignedSurveySummaryDateLineProps {
  assignedSurvey: SurveyV2.AssignedSurveyDto;
}

export const AssignedSurveySummaryDateLine = ({
  assignedSurvey,
}: AssignedSurveySummaryDateLineProps) => {
  const isComplete =
    assignedSurvey.completed && assignedSurvey.completedAt != null;
  const date = isComplete
    ? assignedSurvey.completedAt
    : assignedSurvey.createdAt;
  const prefix = isComplete ? 'Completed on' : 'Assigned on';
  const formattedDate = timeFormatter.epochToHumanReadableDate({
    date,
    showFullMonthName: true,
    excludeRelativeDay: true,
    zone: 'utc',
  });
  const text = `${prefix} ${formattedDate}`;

  return <SummaryDateLine text={text} />;
};
